// extracted by css-extract-rspack-plugin
export default {"action":"action-r01SIX","root":"root-Eoiy38","image":"image-ulN_Dc","textBlock":"textBlock-bA1OTw","title":"title-oHVdgO","lead":"lead-NxH7qQ"};